import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { supabase } from "../../supabase";
import Flower from "../../components/common/Flower/Flower";
import ClickFlower from "../../components/common/ClickFlower/ClickFlower";
import ProjectHeader from "../../components/common/ProjectHeader/ProjectHeader"
import { HowWordsCheck } from "../../functions/getStreak";
import { Link } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import AddChapter from "../../components/chapters/AddChapter";
import ChaptersList from "../../components/chapters/ChaptersList";
import { useRef } from "react";
import { Chart } from "chart.js/auto";



export default function OnlineStats(){
const { id } = useParams(); 
const [project, setProject] = useState(null);

const today = new Date().toISOString().split("T")[0];

const WordsChart = useRef(null);
const TotalWordsChart = useRef(null);

useEffect(() => {
    async function fetchProject() {
      const { data, error } = await supabase
        .from("projects")
        .select("*")
        .eq("id", id)
        .single();

      if (error) {
        console.error(error);
        return;
      }
      setProject(data);
    }

    fetchProject();
}, [id]);


useEffect(() => {
     if (!project?.history) return;

    
    const ctx = WordsChart.current;

    if (!ctx) return;

    const labels = project?.history.map(item => item.date);
    const data = project?.history.map(item => item.words);
    const chart = new Chart(ctx, {
        type: 'line',
        data: {
            labels: labels,
            datasets: [{
                label: 'Historia',
                data: data,
                borderColor: 'rgb(107, 32, 145)',
                tension: 0
            }]
        }
    });
    
    return () => {
        chart.destroy(); 
    };
    
}, [project?.history]);

useEffect(() => {
     if (!project?.history) return;

    let currentWords = 0;
    const ctx = TotalWordsChart.current;

    if (!ctx) return;

    const labels = project?.history.map(item => item.date);
    const data = project?.history.map( item => {
        currentWords += item.words
        return currentWords;
    }
);
const chart = new Chart(ctx, {
    type: 'line',
    data: {
        labels: labels,
        datasets: [{
            label: 'Liczba słów w projekcie',
            data: data,
            borderColor: 'rgb(190, 136, 217)',
            tension: 0
        }]
    }
});

return () => {
    chart.destroy(); 
};

}, [project?.history]);

if (!project) {
  return <div>Ładowanie...</div>;
}

const updateProject = async (updatedProject) => {
    setProject(updatedProject);

    const { error } = await supabase
        .from("projects")
        .update(updatedProject)
        .eq("id", id);

    if (error) {
        console.error(error);
    }
};


    return (
        <div className="projectlist-wrapper">
                    <ProjectHeader
                        headerTitle={'Statystyki'}
                        showBackButton={true}
                        path={`/online/project/${id}`}
                    />
                    <div className="StatsCharts" style={{marginTop: '100px'}} > 
                        <div style={{ width: "500px" }}>
                        <canvas ref={WordsChart}></canvas>
                        </div>
                        <div style={{ width: "500px" }}>
                        <canvas ref={TotalWordsChart}></canvas>
                        </div>
                    </div>
            
                    {project.settings.chaptersEnabled && (
                    <div className="chapters-box"> 
                        <ChaptersList
                        project={project}
                        updateProject={updateProject}/>
                        <AddChapter
                        project={project}
                        updateProject={updateProject}/>
                    </div>
                    )}

                    
        
                </div>
    )
}